// Token store. MVP uses localStorage with explicit keys.
//
// Security trade-off documented in Addendum-01 Q8 + ADR-006:
// access JWT TTL = 365d. For post-MVP move to IndexedDB + WebCrypto.

const ACCESS_KEY = 'syron.access_token';
const REFRESH_KEY = 'syron.refresh_token';
const ACCESS_EXPIRES_KEY = 'syron.access_expires_at';

export interface StoredTokens {
  accessToken: string;
  accessExpiresAt?: string | null;
  refreshToken?: string | null;
}

export const authToken = {
  read(): StoredTokens | null {
    try {
      const at = localStorage.getItem(ACCESS_KEY);
      if (!at) return null;
      return {
        accessToken: at,
        refreshToken: localStorage.getItem(REFRESH_KEY),
        accessExpiresAt: localStorage.getItem(ACCESS_EXPIRES_KEY),
      };
    } catch {
      return null;
    }
  },
  write(t: StoredTokens): void {
    try {
      localStorage.setItem(ACCESS_KEY, t.accessToken);
      if (t.refreshToken) localStorage.setItem(REFRESH_KEY, t.refreshToken);
      if (t.accessExpiresAt) localStorage.setItem(ACCESS_EXPIRES_KEY, t.accessExpiresAt);
    } catch {
      /* storage may be disabled (private mode) — ignore */
    }
  },
  clear(): void {
    try {
      localStorage.removeItem(ACCESS_KEY);
      localStorage.removeItem(REFRESH_KEY);
      localStorage.removeItem(ACCESS_EXPIRES_KEY);
    } catch {
      /* noop */
    }
  },
};
